// extracted by mini-css-extract-plugin
export default {"subscribeButton":"SubscribeButton-module__subscribeButton","button":"SubscribeButton-module__button"};